import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import BookingPage from './pages/BookingPage';
import CheckoutPage from './pages/CheckoutPage';
import NavigationHeader from './components/NavigationHeader';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-white" data-id="element-1">
        <NavigationHeader data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/booking" element={<BookingPage data-id="element-9" />} data-id="element-8" />
          <Route path="/checkout" element={<CheckoutPage data-id="element-11" />} data-id="element-10" />
        </Routes>
      </div>
    </BrowserRouter>;
}